module.exports = __webpack_public_path__ + "static/media/7.f2d455a5.jpg";